import React from 'react';
import PropTypes from 'prop-types';
import LinkToModuleResource from '../../../../common/resource/LinkToModuleResource';
import { ITINERARY_SUGGESTION_META_TYPE } from '../../../../../config/constants';

const ItinerarySuggestionDetailModal = ({ suggestionDetailList }) => (
  <ul>
    {suggestionDetailList.map((suggestionDetail, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={index}>
        {suggestionDetail.message}
        {suggestionDetail.meta &&
          suggestionDetail.meta.type ===
            ITINERARY_SUGGESTION_META_TYPE.GROUP.value && (
            <>
              {' '}
              <LinkToModuleResource
                text=""
                href={`${ITINERARY_SUGGESTION_META_TYPE.GROUP.path}/${suggestionDetail.meta.id}`}
                isExternalPath
              />
            </>
          )}
      </li>
    ))}
  </ul>
);

ItinerarySuggestionDetailModal.propTypes = {
  suggestionDetailList: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string.isRequired,
      meta: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.number,
      }),
    }),
  ).isRequired,
};

export default ItinerarySuggestionDetailModal;
